import { render, staticRenderFns } from "./SingleVideo.vue?vue&type=template&id=78d2247e&scoped=true&"
import script from "./SingleVideo.vue?vue&type=script&lang=js&"
export * from "./SingleVideo.vue?vue&type=script&lang=js&"
import style0 from "./SingleVideo.vue?vue&type=style&index=0&id=78d2247e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d2247e",
  null
  
)

/* custom blocks */
import block0 from "./SingleVideo.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports